import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle, faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import './Modal.css';

const icons = {
  success: faCheckCircle,
  error: faExclamationCircle,
  info: faInfoCircle,
  confirm: faExclamationCircle,
};

export default function Modal({ open, type = 'info', title, message, onClose, onConfirm, confirmLabel = 'Confirm', cancelLabel = 'Cancel', children }) {
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal-popup ${type}`} onClick={(e) => e.stopPropagation()}>
        <button className="modal-popup-close" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="modal-popup-icon">
          <FontAwesomeIcon icon={icons[type] || faInfoCircle} />
        </div>

        {title && <h3 className="modal-popup-title">{title}</h3>}
        {message && <p className="modal-popup-message">{message}</p>}
        {children}

        <div className="modal-popup-actions">
          {type === 'confirm' ? (
            <>
              <button className="modal-popup-btn cancel" onClick={onClose}>{cancelLabel}</button>
              <button className="modal-popup-btn confirm" onClick={onConfirm}>{confirmLabel}</button>
            </>
          ) : (
            <button className="modal-popup-btn ok" onClick={onClose}>OK</button>
          )}
        </div>
      </div>
    </div>
  );
}
